// Material Dashboard 2 React layouts
import Ventas from "layouts/ventas";
//import Vehiculos from "./layouts/abonos";
import VentaProducto from "./layouts/ventaproducto";
import Catalogo from "./layouts/catalogo";
import Comparativa from "./layouts/comparativas"
import Cotizaciones from "./layouts/cotizaciones"
import Mercadopago from "./layouts/busqueda";
import Mostrarventas from "./layouts/mostrarventas";
import Devoluciones from "./layouts/devoluciones";
import Registros from "./layouts/registros";
//import Subir from "./layouts/uploadfile"
import Gastos from "./layouts/gastos"

// @mui icons
import Icon from "@mui/material/Icon";
import Alertas from "./layouts/alertas";
import Stock from "./layouts/stock";




const modules = [
    {
        type: "collapse",
        name: "Busqueda",
        key: "busqueda",
        icon: <Icon fontSize="small">local_grocery_store</Icon>,
        route: "/busqueda",
        component: <Mercadopago/>,
        id:0
    },

    {
        type: "collapse",
        name: "Venta de Productos",
        key: "venta-de-productos",
        icon: <Icon fontSize="small">local_shipping</Icon>,
        route: "/venta-de-productos",
        component: <VentaProducto/>,
        id:1
    },
    {
        type: "collapse",
        name: "Ventas de Yonke",
        key: "ventas",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/ventas",
        component: <Ventas/>,
        id:2
    },
    {
        type: "collapse",
        name: "Mostrar Ventas",
        key: "mostrar-ventas",
        icon: <Icon fontSize="small">query_stats</Icon>,
        route: "/mostrar-ventas",
        component: <Mostrarventas/>,
        id:3
    },
    {
        type: "collapse",
        name: "Devoluciones De Yonke",
        key: "devoluciones-de-yonke",
        icon: <Icon fontSize="small">keyboard_return</Icon>,
        route: "/devoluciones-de-yonke",
        component: <Devoluciones/>,
        id:4
    },
    {
        type: "collapse",
        name: "Gastos",
        key: "gastos",
        icon: <Icon fontSize="small">attach_money</Icon>,
        route: "/gastos",
        component: <Gastos/>,
        id:5
    },
    {
      type: "collapse",
      name: "Abonos",
      key: "abonos",
      icon: <Icon fontSize="small">house</Icon>,
      route: "/abonos",
      component: '<Vehiculos/>',
      id:6
    },
    {
        type: "collapse",
        name: "Alertas",
        key: "alertas",
        icon: <Icon fontSize="small">warning</Icon>,
        route: "/alertas",
        component: <Alertas/>,
        id:7
    },
    {
        type: "collapse",
        name: "Stock",
        key: "stock",
        icon: <Icon fontSize="small">inventory</Icon>,
        route: "/stock",
        component: <Stock/>,
        id:8
    },
    {
        type: "collapse",
        name: "Cotizaciones",
        key: "cotizaciones",
        icon: <Icon fontSize="small">local_offer</Icon>,
        route: "/cotizaciones",
        component: <Cotizaciones/>,
        id:9
    },
    {
        type: "collapse",
        name: "Comparativas",
        key: "comparativas",
        icon: <Icon fontSize="small">compare_arrows</Icon>,
        route: "/comparativas",
        component: <Comparativa/>,
        id:10
    },
    {
        type: "collapse",
        name: "Catalogo",
        key: "catalogo",
        icon: <Icon fontSize="small">menu_book</Icon>,
        route: "/catalogo",
        component: <Catalogo/>,
        id:11
    },
    {
       type: "collapse",
       name: "Subir CSV",
       key: "subir-csv",
       icon: <Icon fontSize="small">cloud_upload</Icon>,
       route: "/subir-csv",
       component: '<Subir/>',
       id:12
     },
    {
        type: "collapse",
        name: "Registros",
        key: "registros",
        icon: <Icon fontSize="small">visibility</Icon>,
        route: "/registros",
        component: <Registros/>,
        id:13
    },

]

const modules_admin= [1,2,3,4,5,7,8,10,0,13]
const modules_manager= [1,2,3,4,7,8,0]
const modules_user= [1,4,7,0]






const routes = localStorage.getItem('rol_id') === '1' ?
    (
        modules_admin.map(index=>modules[index])
    ):
    (
        localStorage.getItem('rol_id') === '4' ?(
                modules_manager.map(index=>modules[index])
            ):
            (
                modules_user.map(index=>modules[index])
            )
    )




export default routes;
